import Util from "../libs/Util";

export default class Nav {
  constructor() {

    this.CL_ACTIVE = "isActive";

    this.CL_FIXED = "isFixed";

    this.isFixed = false;

    this.target = document.querySelector('.page_hotel_detail .nav');
    this.fixedTarget = this.target.querySelector('.-fixed');
    this.navLinks = [...this.target.querySelectorAll('ul li a')];

    this.sections = [];
    this.navLinks.forEach(link => this.sections.push(document.querySelector(link.getAttribute('href'))));

    const sentinel = document.createElement('div');
    sentinel.style.height = '1px';
    sentinel.style.position = 'absolute';
    sentinel.style.top = '-1px';
    sentinel.style.left = '0';
    sentinel.id = 'sentinel';
    this.target.prepend(sentinel);

    const io = new IntersectionObserver(
      ([entry]) => {
        if (!entry.isIntersecting) {
          if (entry.boundingClientRect.top < 0) {
            this.fixedTarget.classList.add(this.CL_FIXED);
          }
        } else {
          this.fixedTarget.classList.remove(this.CL_FIXED);
        }
      },
      {
        root: null,          // viewport
        threshold: 0,
        rootMargin: '0px 0px 0px 0px'
      }
    );

    io.observe(sentinel);

    const mediaQuery = window.matchMedia('(max-width: ' + Util.BREAK_POINT + 'px)');
    mediaQuery.addEventListener('change',this.onMediaQueryChange.bind(this));
    this.onMediaQueryChange(mediaQuery);
  }

  onMediaQueryChange(e) {
    this.onActiveObserver();
  }

  onActiveObserver(){
    if(this.activeObserver) this.activeObserver.disconnect();

    const offset = parseFloat(getComputedStyle(this.sections[0]).scrollMarginTop);

    let activeIds = new Set();
    this.activeObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        const id = entry.target.id;
        if (entry.isIntersecting) {
          activeIds.add(id);
        } else {
          activeIds.delete(id);
        }
      });

      if(activeIds.size === 0) {
        this.navLinks.forEach(link => link.classList.remove(this.CL_ACTIVE));
        return;
      }

      const firstActive = [...activeIds][0];
      this.navLinks.forEach(link => link.classList.remove(this.CL_ACTIVE));
      const activeLink = this.navLinks.find(a => a.getAttribute('href') === '#'+firstActive);
      if (activeLink) activeLink.classList.add(this.CL_ACTIVE);

    }, {
      root: null,
      rootMargin: `-${offset}px 0px -50% 0px`,
      threshold: 0
    });

    this.sections.forEach(section => this.activeObserver.observe(section));
  }
}
